export enum SaleTypeFilterEnum {
  DIRECTED = 'DIRECTED',
  VOL = 'VOL',
  LKP = 'LKP',
  ALL = 'ALL',
}
